import { useCallback } from "react";
import { useQuery } from "react-query";

import client from "../../Client";

export const useGetWorkflowCurrentStepQuery = (
    workflowId?: string,
    enabled: boolean = false,
    refetchInterval?: number
) => {
    const fetchStep = useCallback(async () => {
        const response = await client.get(`/v1/wfo/get-workflow-current-step/${workflowId}`);
        return response.data;
    }, [workflowId]);

    return useQuery(["wfo-current-step", workflowId], fetchStep, {
        enabled: !!workflowId && enabled,
        refetchInterval,
    });
};

export const useGetWorkflowValidatedDataQuery = (workflowId?: string, enabled: boolean = false) => {
    return useQuery(
        ["wfo-validated-data", workflowId],
        async () => (await client.get(`/v1/wfo/get-workflow-validation-data/${workflowId}`)).data,
        { enabled: !!workflowId && enabled }
    );
};
